

import { municipalityOptions } from '@/config'
import { getMunicipalityNameByCode } from '@/services/municipalities'

/**
 * Realisation
 */
class Realisation {
  constructor({
    ref, data,
  }) {

    data = this.commonStructure({ ref, data })
    data.tenant = 'vlaanderen'

    //
    Object.keys(data).forEach(key => {
      this[key] = data[key]
    })
  }
  generateAddressData({ model }) {
    const CurrentLocation = model.CurrentLocation
    const location = CurrentLocation.Location
    const municipality = getMunicipalityNameByCode({ code: model.MunicipalityCode })
    const municipalityName = municipality ? `(${municipality})` : ''

    if (location?.StreetName) {
      return `${location.StreetName} ${location.HouseNumber} ${location.HouseNumberSuffix} ${location.CityName} ${municipalityName}`.replace('  ', ' ')
    }
    return ''
  }
  generateSearchData({ model, data }) {

    let municipalityName = ''
    if (data.Municipality) {
      let municipalityOption = municipalityOptions.find(option => option.value === data.Municipality)
      if (municipalityOption) {
        municipalityName = municipalityOption.text
      }
    }

    return {
      City: model.CurrentLocation ? model.CurrentLocation.Location.CityName : '',
      Municipality: municipalityName,
    }
  }
}





export default Realisation
